module.exports = __webpack_public_path__ + "static/media/hardgate-logo.a213f39c.png";